import { ProductsStoreService } from './../stores/products-store.service';
import { AssementDay } from './../../../shared/modules/evc-api/models/create-quote.dto';
import { SmallBizStoreModel } from './../stores/small-biz-store.model';
import { Injectable } from '@angular/core';
import { CreateQuoteDto, Order } from '@app/shared/modules/evc-api/models/create-quote.dto';
import { Partner } from '@app/shared/modules/evc-api/models/partner-ui.interface';

type ContactInfo = {
  company: string;
  firstName: string;
  lastName: string;
  email: string;
  vatNumber?: string;
  telephone?: string;
  alreadyClient?: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class EvcSmallBizQuoteHelper {
  constructor(private productsStoreService: ProductsStoreService) {}

  public async convertSimulationToQuote(
    contactInfo: ContactInfo,
    model: SmallBizStoreModel,
    virtualAssesment: AssementDay[] | undefined,
    sendOfferOnly: boolean,
    partner: Partner,
    lang: string
  ): Promise<CreateQuoteDto> {
    const order = await this.convertModelToOrder(model);

    return {
      email: contactInfo.email,
      lang,
      sendOfferOnly,
      quote: {
        order,
        energySimulation: false,
        virtualAssesment: virtualAssesment?.length ? virtualAssesment : undefined,
        contactDetails: {
          vatNumber: contactInfo.vatNumber,
          firstName: contactInfo.firstName,
          lastName: contactInfo.lastName,
          companyName: contactInfo.company,
          email: contactInfo.email,
          customer: contactInfo.alreadyClient,
          phone: contactInfo.telephone,
        },
        ...(partner && partner.name ? { partner: partner.name } : {}),
        ...(partner && partner.resellerCode ? { resellerCode: partner.resellerCode } : {}),
      },
    };
  }

  public async convertModelToOrder(model: SmallBizStoreModel): Promise<Order> {
    let total = 0;
    const order: Order = {
      cart: [],
      total: '',
    };

    if (model.chargeCardsAmount > 0) {
      const card = await this.productsStoreService.card$.toPromise();
      const cardPrice = model.chargeCardsAmount * parseInt(card.price, 10);

      order.cart.push({
        code: card.code,
        amount: `${model.chargeCardsAmount}`,
        price: `${cardPrice}`,
      });

      total += cardPrice;
    }

    if (model.chargingStationConfig && model.chargingStationConfig.amount > 0) {
      // TYPE
      const type = await this.productsStoreService.findByChargePointType(model.chargingStationConfig.type).toPromise();
      const typePrice = model.chargingStationConfig.amount * parseInt(type.price, 10);

      order.cart.push({
        code: type.code,
        amount: `${model.chargingStationConfig.amount}`,
        price: `${typePrice}`,
      });
      total += typePrice;

      // LOCATION
      const location = await this.productsStoreService.findByLocation(model.chargingStationConfig.location).toPromise();
      const locationPrice = model.chargingStationConfig.amount * parseInt(location.price, 10);

      order.cart.push({
        code: location.code,
        amount: `${model.chargingStationConfig.amount}`,
        price: `${locationPrice}`,
      });

      total += locationPrice;

      // SMART STATION OPTION
      if (model.chargingStationConfig.smart) {
        const smartStationOption = await this.productsStoreService.smartStationOption$.toPromise();
        const smartStationOptionPrice = model.chargingStationConfig.amount * parseInt(smartStationOption.price, 10);

        order.cart.push({
          code: smartStationOption.code,
          amount: `${model.chargingStationConfig.amount}`,
          price: `${smartStationOptionPrice}`,
        });

        total += smartStationOptionPrice;
      }
    }

    // convert total to string
    order.total = `${total}`;

    return order;
  }
}
